import { useTranslation } from "react-i18next";

interface UpsVideoProps {
    modelName: string;
}
export const UpsVideo = (props: UpsVideoProps) => {
    const { modelName } = props;
    const { t } = useTranslation();
    return (
        <div className="grid-2-col margin-vertical-2 margin-horizontal-1">
            <div className="flex-align-center flex-direction-column">
                <div className="margin-bottom-1 icon-background icon-gift-color">
                    <span className="font-size-2-half icon--ri gift-line"></span>
                </div>
                <p className="reset-margin text-align-center">{t('Gratis Video zur Anmeldung')}</p>
                <small className="text-align-center">{t('Username & E-Mail eingeben und Gratis Video erhalten')}</small>
            </div>
            <div className="flex-align-center flex-direction-column">
                <div className="margin-bottom-1 icon-background icon-database-color">
                    <span className="font-size-2-half icon--ri database-line"></span>
                </div>
                <p className="reset-margin text-align-center">{t('Größte Video Sammlung')}</p>
                <small className="text-align-center">{t('im kompletten Internet von {{modelName}}', { modelName })}</small>
            </div>
            <div className="flex-align-center flex-direction-column">
                <div className="margin-bottom-1 icon-background icon-refresh-color">
                    <span className="font-size-2-half icon--ri refresh-line"></span>
                </div>
                <p className="reset-margin text-align-center">{t('Regelmäßig neue Videos')}</p>
                <small className="text-align-center">{t('von {{modelName}}', { modelName })}</small>
            </div>
            <div className="flex-align-center flex-direction-column">
                <div className="margin-bottom-1 icon-background icon-star-color">
                    <span className="font-size-2-half icon--ri star-line"></span>
                </div>
                <p className="reset-margin text-align-center">{t('Exklusiver Content')}</p>
                <small className="text-align-center">{t('nur hier, nur für dich')}</small>
            </div>
        </div>
    )
}